'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('../../components');

var _Logs = require('../../helpers/Logs');

var _SSOLoginIframe = require('./SSOLoginIframe.scss');

var _SSOLoginIframe2 = _interopRequireDefault(_SSOLoginIframe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var close = require('./../../../res/images/svgExcludeInline/close.svg');

var buttonClear = '#button_clear';

var SSOLoginIframe = (_dec = (0, _reactRedux.connect)(function (state) {
  return { appInfo: state.appInfo, auth: state.auth, captcha: state.captcha, lang: state.auth.lang, log: state.log };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SSOLoginIframe, _Component);

  function SSOLoginIframe() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SSOLoginIframe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SSOLoginIframe.__proto__ || (0, _getPrototypeOf2.default)(SSOLoginIframe)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function () {
      (0, _Logs.logNavigationPopup)(_Logs.LogName.SSOProvider, _Logs.LogName.AuthorizationOptions, _this.props.log, _this.props.auth, _this.props.appInfo);
      _this.props.close();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SSOLoginIframe, [{
    key: 'render',
    value: function render() {
      var url = this.props.provider.loginUrlWithRedirect;
      // TODO GALVIP-3273 Ecran de input des opérateurs
      // Remove this when done
      // const url = this.props.provider.loginUrl + '?redirectUrl=http%3A%2F%2Flocalhost%3A3000%2Fwelcome%2Fvalidatesso%3Fclient_id%3DzBUI4wDBNR1Ikz8L%26' +
      //   'redirect_uri%3Dhttp%253A%252F%252F10.250.143.54%253A4000%252Fplay%252Fbrowse%26response_type%3Dcode%26operator_id%3D' + this.props.provider.id + '%26token%3D%3CoperatorToken%3E';
      // const url = 'http://espaceclient.ccapcable.com/stingray/connexion.php?redirectUrl=http%3A%2F%2Flocalhost%3A3000%2Fwelcome%2Fvalidatesso%3Fclient_id%3DzBUI4wDBNR1Ikz8L%26' +
      //   'redirect_uri%3Dhttp%253A%252F%252F10.250.143.54%253A4000%252Fplay%252Fbrowse%26response_type%3Dcode%26operator_id%3D58%26token%3D%3CoperatorToken%3E';
      return _react2.default.createElement(
        'div',
        { id: _SSOLoginIframe2.default.ssoLoginIframe, className: this.props.className },
        _react2.default.createElement('div', { className: _SSOLoginIframe2.default.dimmer }),
        _react2.default.createElement(
          'div',
          { className: _SSOLoginIframe2.default.providerLogin },
          _react2.default.createElement(
            'div',
            { className: _SSOLoginIframe2.default.providerLoginContent },
            _react2.default.createElement(
              'div',
              { className: _SSOLoginIframe2.default.loginHeader },
              _react2.default.createElement(
                'div',
                { className: _SSOLoginIframe2.default.close },
                _react2.default.createElement(_components.SVGLocal, { viewBox: '0 0 18.38 18.375', link: close + buttonClear, className: _SSOLoginIframe2.default.clearIcon, onClick: this.onClose })
              )
            ),
            _react2.default.createElement('iframe', { className: _SSOLoginIframe2.default.iframe, src: url })
          )
        )
      );
    }
  }]);
  return SSOLoginIframe;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  className: _react.PropTypes.string,
  close: _react.PropTypes.func.isRequired,
  log: _react.PropTypes.object,
  provider: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = SSOLoginIframe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SSOLoginIframe/SSOLoginIframe.js
// module id = 1986
// module chunks = 0